<style>
    .time {
        font-size: 15px;
        font-weight: bold;
    }

    .content {
        padding-left: 10px;
        padding-top:4px;
        padding-bottom: 4px;
        font-size: 13px;
    }
</style>
<template>
    <span>
    <Button @click="showDrawer" type="success" size="small">工作经历</Button>
    <Drawer title="工作经历" :closable="false" placement="right" width="500" v-model="drawerVisible">
    <Timeline>
       <TimelineItem v-for="item in workcourseList">
            <p class="time">工作经历</p>
            <p class="content">公司名称：{{item.companyName}}</p>
            <p class="content">工作年限：{{item.workingLife.text}}</p>
            <p class="content">职位：{{item.position}}</p>
            <p class="content">工作描述：{{item.workTask}}</p>
            <!--<p class="content" v-if="item.isWork == 1" style="color: #52c41a">已认证</p>
            <p class="content" v-if="item.isWork == 3" style="color: red">未通过</p>
            <p class="content" v-if="item.isWork == 2" style="color: blue">未认证</p>-->
        </TimelineItem>
    </Timeline>
    </Drawer>
    </span>
</template>
<script>
    import {workcourseList} from "@/api/index";

    export default {
        name: "workDrawer",
        props: {
            id: ""
        },
        data() {
            return {
                drawerVisible:false,
                workcourseList: []
            }
        },
        methods: {

            //加载数据
            showDrawer() {
                this.type = 1;
                this.drawerTitle = "工作经历";
                this.drawerVisible = true;
                this.getData();

            },
            getaaa(a){
                alert(a.code);
            },
            getData() {
                this.loading = true;
                workcourseList(this.id).then(res => {
                    this.loading = false;
                    if (res.status === true) {
                        this.workcourseList = res.data;
                    }
                });
            }

        }
    }
</script>